// Full-bleed background globe — fills the entire hero as a backdrop. Content overlays on top.
import { useState } from "react";
import GlobeHero from "@/components/GlobeHero";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const GLOBE_VIDEO = `${BACKEND_URL}/api/media/globe-bg.mp4`;

export default function SpaceHero() {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return (
      <div className="absolute inset-0 flex items-center justify-end pr-[5vw]">
        <div className="w-[min(72vw,820px)] aspect-square">
          <GlobeHero height={820} />
        </div>
      </div>
    );
  }

  return (
    <div data-testid="hero-globe" className="absolute inset-0 overflow-hidden" aria-hidden="true">
      <video
        src={GLOBE_VIDEO}
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        className="absolute top-1/2 left-1/2 min-w-full min-h-full w-auto h-auto -translate-x-1/2 -translate-y-1/2 object-cover"
        onError={(e) => {
          const code = e?.currentTarget?.error?.code;
          if (code === 1) return;
          setFailed(true);
        }}
      />
    </div>
  );
}
